<template>
  <div class="page-trends-insights">
    <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <h1 class="h2 mb-3">2020 Trends and Insights Report</h1>
    <b-row v-if="!hasAccess">
      <b-col md="12">
        Access denied. Please make sure the user you are logged in to has access to this file...
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col md="12">
        <a :href="`${getServerUrl()}/api/getFile/2020trendsinsights`">
          <img src="/img/2020-TrendsInsights-Report.jpg" style="max-width: 550px;"/>
        </a><br />
        Your copy of the 2020 Industry Trends and Insights Report is ready to download!<br /><br />
        <a :href="`${getServerUrl()}/api/getFile/2020trendsinsights`">Click here to download</a>
      </b-col>
      <b-col md="6">
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;

const tiBadges = [
  'Campground Member',
  'Campground Member - Partnering',
  'State Association',
  'Associate',
  'Board of Directors',
  'Industry Survey 2020',
  'MBP',
  'Business Forum',
  'Industry Partner',
  'Supplier Council Member',
  'Pending Partnering State Member',
];

export default {
  name: 'TrendsInsights',
  data() {
    return {
      loading: true,
      hasAccess: false,
    };
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        const rawContact = await axios.get(`${server}/api/contact`);
        if (rawContact.data.redirect) {
          window.location.href = rawContact.data.redirect;
          return;
        }

        if (rawContact.data.OrderApi__Badges__c) {
          const userBadges = rawContact.data.OrderApi__Badges__c.split(',');
          const matchedBadges = userBadges.filter((x) => tiBadges.includes(x));
          if (matchedBadges.length > 0) {
            this.hasAccess = true;
          }
        }

        this.picklists = rawContact.data.picklists;
        this.form = rawContact.data;
        this.loading = false;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200);
      } catch (err) {
        console.log({ getContactError: err });
        this.loadingMessage = 'There was an issue pulling your personal info. Please let us know so we can take a look!';
      }
    });
  },
  methods: {

    getServerUrl() {
      return server;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
</style>
